import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AliasColecaoService {
  private readonly STORAGE_KEY = 'aliasColecao';
  private readonly DEFAULT_ALIAS = 'Coleção';
  
  private aliasSubject = new BehaviorSubject<string>(this.DEFAULT_ALIAS);
  public alias$: Observable<string> = this.aliasSubject.asObservable();

  constructor(private http: HttpClient) {
    this.carregarAlias();
  }

  private carregarAlias(): void {
    const alias = localStorage.getItem(this.STORAGE_KEY);
    if (alias && alias.trim()) {
      this.aliasSubject.next(alias);
    }
  }

  carregarAliasDaRede(): void {
    const idCompany = localStorage.getItem('idCompany');
    
    if (!idCompany) {
      this.setAlias(null);
      return;
    }

    const urlLogistica = localStorage.getItem(env.baseApiModuleLogistic.toString());
    
    if (!urlLogistica) {
      this.setAlias(null);
      return;
    }

    this.http.get<any>(`${urlLogistica}api/v1/Empresa/consulta?codigo=${idCompany}`, {
      headers: { pagina: '1', itensPorPagina: '1', ordenadoPor: '', direcao: '' }
    }).subscribe({
      next: (response) => {
        const empresa = response?.data?.[0];
        this.setAlias(empresa?.aliasColecao);
      },
      error: () => {
        this.setAlias(null);
      }
    });
  }

  setAlias(alias: string | null | undefined): void {
    const valorFinal = alias?.trim() || this.DEFAULT_ALIAS;
    localStorage.setItem(this.STORAGE_KEY, valorFinal);
    this.aliasSubject.next(valorFinal);
  }

  getAlias(): string {
    return this.aliasSubject.value;
  }

  getAliasPlural(): string {
    const alias = this.getAlias();
    const partes = alias.split(' ');
    partes[0] = this.pluralizarPalavra(partes[0]);
    return partes.join(' ');
  }

  private pluralizarPalavra(palavra: string): string {
    const rules: [RegExp, string][] = [
      [/ão$/, 'ões'],
      [/m$/, 'ns'],
      [/l$/, 'is'],
      [/[rz]$/, '$&es'],
      [/s$/, 's'],
    ];

    for (const [regex, suffix] of rules) {
      if (regex.test(palavra)) {
        return palavra.replace(regex, suffix);
      }
    }

    return palavra + 's';
  }

  reverter(texto: string): string {
    if (!texto) return texto;
    const pares = [[this.getAlias(), 'Coleção']];
    for (const [alias, original] of pares) {
      if (alias.toLowerCase().startsWith(texto.toLowerCase())) return original;
    }
    return texto;
  }

  substituir(texto: string): string {
    if (!texto) return texto;
    
    const singular = this.getAlias();
    const plural = this.getAliasPlural();
    
    return texto
      .replace(/\bColeções\b/g, plural)
      .replace(/\bcoleções\b/g, plural.toLowerCase())
      .replace(/\bColeção\b/g, singular)
      .replace(/\bcoleção\b/g, singular.toLowerCase());
  }
}
